import frFR from "rsuite/locales/fr_FR";
import enUS from "rsuite/locales/en_US";
import esES from "rsuite/locales/es_ES";
import nlNL from "rsuite/locales/nl_NL";
import itIT from "rsuite/locales/it_IT";
import caES from "rsuite/locales/ca_ES";

// Note: React Suite doesn't have specific locales for Basque, so we use 'frFR' instead

export const rSuiteTranslationsForLocale = locale => {
  switch (locale) {
    case "fr":
      return frFR;
    case "en":
      return enUS;
    case "es":
      return esES;
    case "nl":
      return nlNL;
    case "it":
      return itIT;
    case "eu":
      return frFR;
    case "ca":
      return caES;
    default:
      return enUS;
  }
};
